<template>
  <v-navigation-drawer
    app
    v-model="model"
    :mobile-breakpoint="$vuetify.breakpoint.thresholds.sm"
  >
    <v-list dense nav class="py-0">
      <v-list-item>
        <v-img
          aspect-ratio="2"
          contain
          rel="preload"
          :src="$store.getters['config/getOrganizationLogo']"
        ></v-img>
      </v-list-item>

      <v-divider class="mb-4"></v-divider>
      <NavItem
        v-for="item in navItems"
        :title="$t(item.title)"
        :icon="item.icon"
        :route="item.route"
        :key="item.route"
        :display_getter="item.display_getter"
      ></NavItem>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import NavItem from "./components/NavItem";
export default {
  name: "Drawer",
  components: { NavItem },
  data() {
    return {
      model: this.$vuetify.breakpoint.mdAndUp,
      navItems: [
        {
          title: "nav.home",
          icon: "mdi-home",
          route: "home"
        },
        {
          title: "nav.campaigns",
          icon: "mdi-ticket",
          route: "campaigns",
          display_getter: "config/hasCampaigns"
        },
        {
          title: "nav.transactions",
          icon: "mdi-account-cash-outline",
          route: "transactions",
          display_getter: "config/showTransactionsMenuTab"
        },
        {
          title: "nav.subscriptions",
          icon: "mdi-cash-sync",
          route: "subscriptions",
          display_getter: "config/isSubscriptionsAllowed"
        },
        {
          title: "nav.invoices",
          icon: "mdi-invoice-list",
          route: "invoices",
          display_getter: "user/expectsInvoices"
        },
        {
          title: "nav.account_settings",
          icon: "mdi-cog",
          route: "settings"
        }
      ]
    };
  },
  mounted() {
    if (this.$store.state.config.has_cashout_license) {
      this.navItems.splice(this.navItems.length - 1, 0, {
        title: "nav.cashout_requests",
        icon: "mdi-currency-eur",
        route: "cashout-requests"
      });
    }
    if (
      this.$store.state.config.webshop_configuration !== null &&
      this.$store.state.config.webshop_configuration.mode === "enabled"
    ) {
      this.navItems.splice(
        this.navItems.length - 1,
        0,
        {
          title: "nav.webshop",
          icon: "mdi-store",
          route: "webshop"
        },
        {
          title: "nav.online_purchases",
          icon: "mdi-cart-check",
          route: "online-purchases"
        }
      );
    }
  },
  computed: {
    navTrigger() {
      return this.$store.state.viewstate.navigationDrawer.trigger;
    }
  },
  watch: {
    navTrigger: function() {
      this.model = !this.model;
    }
  }
};
</script>

<style scoped>
.theme--dark.v-navigation-drawer {
  background-color: #272727;
}
</style>
